import { render, staticRenderFns } from "./LoyaltyProgramsForm.vue?vue&type=template&id=884480b8"
import script from "./LoyaltyProgramsForm.vue?vue&type=script&lang=ts"
export * from "./LoyaltyProgramsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports